const FILTERS_LOTLIST_SESSION_KEY_NAME : string = "Filters.LotList";

export const persistSortOrder = (persistKey: string, sortOrder: string) => {
    // persist to local storage
    sessionStorage.setItem(`SortOrder.${persistKey}`, JSON.stringify(sortOrder));
}

export const getSortOrder = (persistKey: string) => {
    let sortOrder = sessionStorage.getItem(`SortOrder.${persistKey}`);

    if (sortOrder) {
        return JSON.parse(sortOrder);
    }
}

export const persistLotListFilters = (key: string, value: any) => {
    // get filters for all columns
    let filters = getLotListFilters();

    // First call to this we won't have a value for filters
    if (filters === undefined) {
        filters = {};
    }
    
    // This should always be true or false, but just in case check for undefined
    if (value !== undefined) {
        // Add/update filter values
        filters[key] = value; 

        sessionStorage.setItem(FILTERS_LOTLIST_SESSION_KEY_NAME, JSON.stringify(filters));
    }
    else {
        // Remove filter if filter value is undefined
        if (filters) {
            if (key === 'includeGraded') {
                // Our default for this is false, see lot list
                filters.includeGraded = false;
            } else {
                filters[key] = undefined; 
            }

            sessionStorage.setItem(FILTERS_LOTLIST_SESSION_KEY_NAME, JSON.stringify(filters));
        }
    }
}

export const persistTableFilters = (persistKey: string, filters: string) => {
    // persist to local storage
    sessionStorage.setItem(`Filters.${persistKey}`, JSON.stringify(filters));
}

export const getTableFilters = (persistKey: string) => {
    let tableFilters = sessionStorage.getItem(`Filters.${persistKey}`);
    if (tableFilters) {
        return JSON.parse(tableFilters);
    }
}

export const getLotListFilters = () => {
    let filters = sessionStorage.getItem(FILTERS_LOTLIST_SESSION_KEY_NAME);
    if (filters) {
        return JSON.parse(filters);
    }
}

export const setCacheItem = (key: string, value: any) : void => {
    sessionStorage.setItem(key, value);
}

export const getCacheItem = (key: string): any => {
    let val = sessionStorage.getItem(key);
    return val != null ? JSON.parse(val ?? "") : null;
}